
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import {
    CodeBlock, BlockType, SettingOption, SettingType, Setting, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class PWM extends BasePeripheral {
    constructor() {
        super();
        this.id = 'pwm';
        this.name = 'PWM';
        this.requirements = [['zephyr', 'micropython']];
        const settings: Array<Setting> = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'PIN',
                name: 'PIN',
                settingType: SettingType.PIN,
                meta: 'pwm',
                required: true,
                default: '',
            },
            {
                id: 'DUTY',
                name: 'Duty Cycle (0~100)',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                required: true,
                default: 'PWM_DUTY',
                helpText: 'The duty cycle is the proportion of "on" time for the channel, where 0 is always off and 100 is always on.',
            },
            {
                id: 'FREQUENCY',
                name: 'Frequency (1~20000)',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                required: true,
                default: 'PWM_FREQ',
                helpText: 'The unit for the value range is hertz, meaning the usable range is from 1Hz to 20Khz.',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'PORT') {
            const options = [];
            const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
            for (let i = 0; i < device.peripherals.length; i++) {
                if (device.peripherals[i].type === 'pwm') {
                    options.push({
                        name: device.peripherals[i].id,
                        value: device.peripherals[i].settings.PORT.value,
                    });
                }
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    getState(settingId: string): SettingState {
        if (settingId === 'PORT') {
            const PIN = this.getSettingValue('PIN');
            if (PIN) {
                return SettingState.DISABLED;
            }
        }
        return super.getState(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
